// extracted by mini-css-extract-plugin
module.exports = {"notSupported":"NotSupportedPlaceholder_notSupported__1irPj"};